export enum ActionName {
  Decrement = 'onMonthDecrement',
  Increment = 'onMonthIncrement',
  MonthChange = 'onMonthChange'
}
